export { fetchWidgetSpecs } from './widget-specs';
export { fetchTemplates, fetchTemplateById } from './templates';
export * from './user';
export { fetchTournamentById } from './tournaments';
export { fetchPortfolio } from './portolio';
export { fetchTeamById, fetchTeamsBySportAndLeague } from './teams';
export { fetchEventById, fetchEventsByTournament, fetchEventsByDate } from './events';



/** WEBPACK FOOTER **
 ** ../src/dash/front/actions/index.js
 **/